import { combineReducers } from 'redux';
import progress from './progress.reducer';

const progressAppReducer = combineReducers({
    progress,
});

export default progressAppReducer;


// WEBPACK FOOTER //
// src/main/content/progress/store/reducers/index.js